import React from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const AdminLayout = ({ children }) => {
    const { logout, user } = useAuth();
    const navigate = useNavigate();
    const [isSidebarOpen, setIsSidebarOpen] = React.useState(true);

    const handleLogout = () => {
        logout();
        navigate('/login');
    };

    const navItems = [
        { path: '/', label: 'Dashboard', icon: '📊' },
        { path: '/users', label: 'Usuarios', icon: '👥' },
        { path: '/salas', label: 'Salas', icon: '🏢' },
        { path: '/agenda', label: 'Agenda', icon: '📅' },
        { path: '/speakers', label: 'Conferencistas', icon: '🎙️' },
        { path: '/questions', label: 'Preguntas', icon: '❓' },
        { path: '/streaming', label: 'Streaming', icon: '📺' },
        { path: '/surveys', label: 'Encuesta', icon: '📝' },
        { path: '/survey-stats', label: 'Estadísticas Encuesta', icon: '📈' },
        { path: '/trivia', label: 'Preguntas Trivia', icon: '🎯' },
        { path: '/resultados', label: 'Resultados Votación', icon: '🏆' },
        { path: '/reportes', label: 'Reportes Completos', icon: '📈' },
        ...(user?.role === 'admin' ? [
            { path: '/configs', label: 'Configuración', icon: '⚙️' },
            { path: '/pages-builder', label: 'Creador Páginas', icon: '🎨' }
        ] : []),
    ];

    return (
        <div className="flex h-screen bg-gray-100 relative overflow-hidden">
            {/* Sidebar Toggle Button (Mobile/Tablet) */}
            <button
                onClick={() => setIsSidebarOpen(!isSidebarOpen)}
                className="fixed bottom-10 left-6 z-[200] w-14 h-14 bg-slate-900 text-white rounded-full shadow-2xl flex items-center justify-center border border-slate-700 transition-transform active:scale-90 lg:hidden"
            >
                {isSidebarOpen ? '✕' : '☰'}
            </button>

            {/* Sidebar */}
            <aside className={`fixed lg:relative z-[150] w-64 bg-slate-900 text-white flex flex-col shadow-xl h-full transition-transform duration-300 transform ${isSidebarOpen ? 'translate-x-0' : '-translate-x-full lg:translate-x-0 lg:w-0'}`}>
                <div className="p-6 border-b border-slate-800 flex flex-col items-center bg-slate-950 min-w-[256px]">
                    <h1 className="text-xl font-black text-white italic tracking-tighter uppercase">Administrador <sup className="text-[10px]"> PCN </sup> Plataforma </h1>
                    <h1 className="text-2xl font-black text-white mt-[-5px] tracking-tight uppercase">Evento</h1>
                </div>
                <nav className="flex-grow p-4 space-y-2 mt-4 overflow-y-auto min-w-[256px]">
                    {navItems.map((item) => (
                        <NavLink
                            key={item.path}
                            to={item.path}
                            onClick={() => {
                                if (window.innerWidth < 1024) setIsSidebarOpen(false);
                            }}
                            className={({ isActive }) =>
                                `flex items-center p-3 rounded-lg transition-all duration-200 ${isActive
                                    ? 'bg-blue-600 text-white shadow-lg shadow-blue-900/50 scale-105'
                                    : 'text-slate-400 hover:bg-slate-800 hover:text-white'
                                }`
                            }
                        >
                            <span className="mr-3 text-xl">{item.icon}</span>
                            <span className="font-medium text-xs uppercase tracking-widest">{item.label}</span>
                        </NavLink>
                    ))}
                </nav>
                <div className="p-4 border-t border-slate-800 bg-slate-950/50 min-w-[256px]">
                    <div className="flex items-center mb-4 px-2">
                        <div className="w-10 h-10 rounded-full bg-blue-500 flex items-center justify-center text-white font-bold mr-3">
                            {user?.name?.[0].toUpperCase()}
                        </div>
                        <div className="overflow-hidden">
                            <p className="text-sm font-semibold truncate">{user?.name}</p>
                            <p className="text-xs text-slate-500 truncate capitalize">{user?.role}</p>
                        </div>
                    </div>
                    <button
                        onClick={handleLogout}
                        className="w-full flex items-center justify-center p-3 text-red-400 hover:bg-red-500/10 rounded-lg transition-colors border border-transparent hover:border-red-500/20"
                    >
                        <span className="mr-3">🚪</span> Logout
                    </button>
                </div>
            </aside>

            {/* Main Content */}
            <main className={`flex-grow overflow-auto p-4 lg:p-8 transition-all duration-300 ${!isSidebarOpen ? 'lg:pl-8' : ''}`}>
                <div className="max-w-7xl mx-auto animate-fadeIn pb-20">
                    {children}
                </div>
            </main>
        </div>
    );
};

export default AdminLayout;
